import React, { useCallback, useEffect, useState } from 'react'
import { SkeletonList } from '../../components/Skeleton'
import {
  BackLink,
  Card,
  CardTitle,
  ContentMaxWidth,
  Muted,
  PageHeading,
  PageSubheading,
  Pill,
  Stack,
} from '../../layout/styledComponents'
import { usePatient } from '../../context/PatientContext'
import * as svc from '../../services/recordsService'
import { parseUtcDate } from '../../utils/dates'

export default function NotesPage() {
  const { currentProfile } = usePatient()
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  const refresh = useCallback(async () => {
    if (!currentProfile) return
    setLoading(true)
    try {
      const res = await svc.listNotes(currentProfile)
      setData(res)
    } finally {
      setLoading(false)
    }
  }, [currentProfile])

  useEffect(() => {
    setData(null)
    refresh()
  }, [refresh])

  return (
    <ContentMaxWidth>
      <Stack $gap="20px">
        <BackLink to="/patient-home/records">Back to Records</BackLink>
        <div>
          <Pill>Records</Pill>
          <PageHeading style={{ marginTop: 12 }}>Notes shared with me</PageHeading>
          <PageSubheading>Notes your practitioner has explicitly shared with you.</PageSubheading>
        </div>

        {loading && !data ? (
          <SkeletonList count={3} />
        ) : !data?.items?.length ? (
          <div
            style={{
              padding: '48px 24px',
              textAlign: 'center',
              border: '1px dashed rgba(31,41,55,0.18)',
              borderRadius: 20,
            }}
          >
            <p style={{ fontSize: 18, marginTop: 0, marginBottom: 8 }}>No shared notes yet.</p>
            <Muted>Practitioners can share notes with you between sessions — those land here.</Muted>
          </div>
        ) : (
          <Stack $gap="12px">
            {data.items.map((n) => (
              <Card key={n.id}>
                <CardTitle style={{ marginBottom: 4 }}>{n.title}</CardTitle>
                <Muted>
                  {n.practitionerName} ·{' '}
                  {parseUtcDate(n.sharedAt).toLocaleDateString([], {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                  })}
                </Muted>
                <p style={{ marginTop: 12, lineHeight: 1.6, color: '#1F2937' }}>{n.body}</p>
              </Card>
            ))}
          </Stack>
        )}
      </Stack>
    </ContentMaxWidth>
  )
}
